<ng-container *ngIf="messages.length">
  <app-message #idMessage *ngFor='let message of messages' [message]='message' [timeout]="timeout" (dismiss)="onDismissMessage(message.id)"></app-message>
</ng-container>